import Axios from "axios";
import { Auth } from "aws-amplify";

export const axiosSecretKey = Axios.create({
  headers: {
    secret_afinando_key: "YWZpbmFuZG9fMl90b19uZXh0XzM=",
  },
});
const axios = Axios.create({});

// 1. Interceptor de Requisição: Injeta o token antes de enviar
axios.interceptors.request.use(
  async (config) => {
    if (config.forceWithoutAuth) {
      delete config.headers.Authorization;
      return config;
    }
    if (config.headers?.Authorization) {
      return config;
    }
    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();
      config.headers.Authorization = token;
    } catch (error) {
      // Se não houver sessão ativa (ex: login), a requisição segue sem token
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 2. Interceptor de Resposta: Trata o erro 401 e renova a sessão
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Se for 401 e ainda não tentamos refazer esta requisição
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();

        // Renova o token via Amplify
        const newSession = await new Promise((resolve, reject) => {
          cognitoUser.refreshSession(
            currentSession.getRefreshToken(),
            (err, session) => {
              if (err) reject(err);
              else resolve(session);
            }
          );
        });

        // Atualiza o cabeçalho com o novo token e refaz a chamada original
        const newToken = newSession.getIdToken().getJwtToken();
        originalRequest.headers.Authorization = newToken;

        return axios(originalRequest);
      } catch (refreshError) {
        // Se a renovação falhar (refresh token expirou), força o logout
        Auth.signOut();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axios;